const clientIpUrl = '/api/request/client/ip';

export const fetchClientIp = async () => {
  return await fetch(clientIpUrl)
    .then(result => result.json())
    .then(jsonData => {
      // eslint-disable-next-line no-prototype-builtins
      return jsonData.hasOwnProperty('hasIpMatch') ? jsonData.hasIpMatch : null;
    });
};

export const setCookie = async() => {
  return await fetch('/api/request/client/setcookie').then(result => result.json()).then(cookieData => {
    return cookieData.cookie;
  });
};
